import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
const API = `${process.env.REACT_APP_BACKEND_URL}/api/operations/board-organization/manager`;

export function useManagerOrder(managerId, onMutated) {
  const activeManager = useRef(managerId);
  activeManager.current = managerId;
  const [loaded, setLoaded] = useState({ id: "", sections: {} });
  const sectionOrders = loaded.id === managerId ? loaded.sections : {};
  const reload = useCallback(async () => {
    if (!managerId) return;
    const result = await axios.get(`${API}/${encodeURIComponent(managerId)}`);
    if (activeManager.current === managerId) setLoaded({ id: managerId, sections: result.data.section_orders || {} });
  }, [managerId]);
  useEffect(() => { reload().catch(() => toast.error("Could not load manager ordering.")); }, [reload]);
  const change = async (section, action, values = {}) => {
    if (!managerId || loaded.id !== managerId) return;
    try {
      await axios.post(`${API}/${encodeURIComponent(managerId)}/sections/${section}`, {
        action, expected_version: sectionOrders[section]?.version ?? 0, ...values,
      });
      await reload();
      await onMutated();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Manager ordering could not be saved.");
      await reload().catch(() => {});
    }
  };
  const move = (kind, id, section, after) => change(section, "move", {
    kind, item_id: id, after_kind: after?.kind || "project", after_id: after?.id || "",
  });
  return { sectionOrders, orgMap: {}, dividers: [],
    frozenSections: Object.keys(sectionOrders).filter(key => sectionOrders[key].frozen),
    move: (id, section, after) => move("project", id, section, after),
    moveDivider: (id, section, after) => move("divider", id, section, after),
    restoreSection: section => change(section, "restore"),
    freezeSection: section => change(section, "freeze"),
    unfreezeSection: section => change(section, "unfreeze"),
  };
}
